function computeSlotTaken(length: number) {
  switch (length) {
    case 1:
      return '-x33'
    case 2:
      return '-x70'
    default:
      return '-x100'
  }
}
/**
 *
 * @param attributeDisplays
 * @param typeBased will check if type is list, single or multiselect slotTaken is -x30 else -x100; default: true
 * @returns attributeDisplays with computed slot taken and withBreakLine
 */
export default function attributeComputeSlotTaken(attributeDisplays: any[], typeBased = true) {
  const result = structuredClone(attributeDisplays)
  return result.map((item, index) => {
    let withBreakLine = false
    let slotTaken = '-x33'
    const lastIndex = result.length - 1

    let attributeArray = null

    switch (item.type) {
      case 'table':
        if (Array.isArray(item.attribute) && Array.isArray(item.attribute[0]))
          attributeArray = item.attribute[0]
        break
      default:
        attributeArray = [item.attribute]
        break
    }

    if (typeBased) {
      slotTaken = computeSlotTaken(attributeArray?.length ?? 0)
    } else {
      switch (item.type) {
        case 'single':
          withBreakLine = index > 0 && result[index - 1].type !== 'single'
          break
        case 'table':
        case 'list':
          if ((index < lastIndex && result[index + 1].type === 'single') || index === lastIndex)
            slotTaken = computeSlotTaken(attributeArray?.length ?? 0)
          break
      }
    }

    return {
      ...item,
      slotTaken,
      withBreakLine,
    }
  })
}
